<template>
    <div>
        <p class="mx-auto text-primary text-center font-weight-bold">فراموشی کلمه عبور</p>
        <p class="text-small text-center text-grey-darken-1">چنانچه کلمه عبور خود را فراموش کرده اید، نام کاربری، شماره موبایل یا آدرس ایمیل خود را برای دریافت کد احراز هویت جهت ایجاد کلمه عبور جدید وارد نمایید</p>
        <v-form class="mt-5 px-4" @submit.prevent="invalidPassword ? '' : $emit('submited', password)">
            <v-text-field
                :error="invalidPassword"
                :append-inner-icon="pass1 ? 'visibility' : 'visibility_off'"
                :type="pass1 ? 'password' : 'text'"
                @click:appendInner="() => {pass1 = !pass1;}"
                hide-details
                label="کلمه عبور"
                class="mx-auto"
                v-model="password"
            ></v-text-field>
            <v-progress-linear
                :bg-color="`${passwordStrengthColor[passwordStrength]}30`"
                :color="passwordStrengthColor[passwordStrength]"
                :model-value="passwordStrength*25"
                class="mb-4 mt-1 rounded"
            ></v-progress-linear>
            <v-btn type="submit" :loading="loading" class="mx-auto d-block mt-1" color="primary" >
                <v-icon class="pe-3" size="18">icon-key</v-icon>
                <p class="text-small text-white">اعمال تغییرات</p>
            </v-btn>
        </v-form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            password: '',
            pass1: true,
            passwordStrengthColor: [
                "#777777",
                "#ef2f2e",
                "#fe8025",
                "#fedb41",
                "#10bb67",
            ],
        };
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        passwordStrength() {
            return Number(/[a-z]/.test(this.password)) +
                Number(/[A-Z]/.test(this.password)) +
                Number(/[0-9]/.test(this.password)) +
                Number(this.password.length >= 8);
        },
        invalidPassword() {
            return this.$system.systemSettings.force_users_using_secure_password && this.passwordStrength != 4;
        },
    },
};
</script>
